const initialState = {    
    //invoices search
    pageSize: 10,
    activePage: 1,
    loadingProviders: true,
    providersList: [],
    sortDirection: true,
    oneProvider: [],
    message: "The list is empty",
    activeOnly: "All",

    taxRatesList:[],
    taxRatesPickedCountry: {value: "0", name: "default"},
    oneTaxRate: [],
    activeOnlyTaxRate: "All",
    pageSizeTaxRate: 10,
    activePageTaxRate: 1,

    usersList: [],

    oneUser: {},

    oneProviderCertificate: {},

    providerVisibleColumns:{
        "full_name": false,
        "email": false,
        "phone_number": false,
        "deleted": false,
        "countries": false
    },

    providerTaxRateVisibleColumns:{
        "country": false,
        "tax_rate_mark": false,
        "tax_rate": false,
        "tax_rate_description": false,
    },

    providerUserVisibleColumns:{
        "username": false,
        "email": false,
        "first_name": false,
        "last_name": false,
        "account_non_expired": false,
        "credentials_non_expired": false,
        "account_non_locked": false,
        "enabled": false,
        "created": false
    }
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    let item
    switch (action.type) {

    case "MAP_ONE_PROVIDER_CERTIFICATE_DETAILS":
        return{
            ...state,
            oneProviderCertificate: action.data
        }

    case "MAP_PROVIDER_USERS_LIST":
        return{
            ...state,
            usersList: action.data
        }

    case "MAP_PROVIDER_TAX_RATE_ACTIVE_ONLY":
        return{
            ...state,
            activeOnlyTaxRate: action.data
        }

    case "MAP_PROVIDER_TAX_RATE_LIST_ACTIVE_PAGE":
        return{
            ...state,
            activePageTaxRate: action.data        
        }

    case "MAP_PROVIDER_TAX_RATE_LIST_PAGE_SIZE":
        return{
            ...state,
            pageSizeTaxRate: action.data        
        }

    case "TOGGLE_PROVIDER_TAX_RATE_VISIBLE_COLUMN":
        item = action.data.dataField
        return{
            ...state,
            providerTaxRateVisibleColumns: {
                ...state.providerTaxRateVisibleColumns,
                [item]: !action.data.hidden
            }
        }

    case "TOGGLE_PROVIDER_USER_VISIBLE_COLUMN":
        item = action.data.dataField
        return{
            ...state,
            providerUserVisibleColumns: {
                ...state.providerUserVisibleColumns,
                [item]: !action.data.hidden
            }
        }

    case "TOGGLE_PROVIDER_USER_VISIBLE_COLUMN_ALL":
        return{
            ...state,
            providerUserVisibleColumns: action.data
        }

    case "CHANGE_PROVIDER_ONE_USER_DETAILS":
        item = action.data.id
        return{
            ...state,
            oneUser: {
                ...state.oneUser,
                [item]: action.data.value
            }
        }
        
    case "MAP_PROVIDER_ONE_USER":
        return{
            ...state,
            oneUser: action.data
        }     


    case "CHANGE_PROVIDER_ONE_TAX_RATE_DETAILS":
        item = action.data.id
        return{
            ...state,
            oneTaxRate: {
                ...state.oneTaxRate,
                [item]: action.data.value
            }
        }
        
    case "MAP_PROVIDER_ONE_TAX_RATE":
        return{
            ...state,
            oneTaxRate: action.data
        }  

    case "MAP_PROVIDERS_TAX_RATES_LIST":
        return{
            ...state,
            taxRatesList: action.data
        }

    case "MAP_PROVIDERS_TAX_RATES_PICKED_COUNTRY":
        return{
            ...state,
            taxRatesPickedCountry: action.data
        }

    case "MAP_PROVIDER_VISIBLE_COLUMN":
        return{
            ...state,
            providerVisibleColumns: action.data
            
        }

    case "TOGGLE_PROVIDER_VISIBLE_COLUMN":
        const providerColumn = action.data.dataField
        return{
            ...state,
            providerVisibleColumns: {
                ...state.providerVisibleColumns,
                [providerColumn]: !action.data.hidden
            }
        }

    case "MAP_ONE_PROVIDER_DETAILS":
        return{
            ...state,
            oneProvider: action.data
        }  

    case "MAP_LOADING_PROVIDER":
        return{
            ...state,
            loadingProviders: action.data
        }  
            
    case "CHANGE_ONE_PROVIDER_DETAILS":
        let userKey = action.data.id
        let value = action.data.value
        return{
            ...state,
            oneProvider: {
                ...state.oneProvider,
                [userKey]: value === "on" ? !state.oneProvider[userKey] : value
            }
        }

    case "MAP_PROVIDER_ACTIVE_ONLY":
        return{
            ...state,
            activeOnly: action.data
        }

    case "MAP_PROVIDER_LIST":
        return{
            ...state,
            providersList: action.data
        }

    case "MAP_PROVIDER_LIST_PAGE_SIZE":
        return{
            ...state,
            pageSize: action.data        
        }

    case "MAP_PROVIDER_LIST_ACTIVE_PAGE":
        return{
            ...state,
            activePage: action.data        
        }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
